import { render, staticRenderFns } from "./CowsWeightRecording.vue?vue&type=template&id=50fc0b4e&scoped=true&"
import script from "./CowsWeightRecording.vue?vue&type=script&lang=js&"
export * from "./CowsWeightRecording.vue?vue&type=script&lang=js&"
import style0 from "./CowsWeightRecording.vue?vue&type=style&index=0&id=50fc0b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc0b4e",
  null
  
)

export default component.exports